export default function priceFormatter(price, hideCurrency) {
  return `${new Intl.NumberFormat("da-DK", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price)}${
    hideCurrency ? "" : " DKK"
  }`
}
